import { createFileRoute } from "@tanstack/react-router";
import { BlockRenderer } from "~/components/blocks";
import { loadStandalonePage } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/developers")({
  loader: async () => {
    const page = await loadStandalonePage({ data: { path: "developers/_index.md" } });
    return {
      title: (page.title as string) || "Developer hub",
      seo_title: page.seo_title as string | undefined,
      seo_description: page.seo_description as string | undefined,
      blocks: (page.blocks as any[]) || [],
    };
  },
  head: ({ loaderData }) => ({
    meta: seo({
      title: loaderData?.seo_title || loaderData?.title,
      description: loaderData?.seo_description || "",
      url: "/developers",
    }),
    links: seoLinks({ url: "/developers" }),
  }),
  component: DeveloperHubPage,
});

function DeveloperHubPage() {
  const page = Route.useLoaderData();
  return <BlockRenderer blocks={page.blocks} />;
}
